/* Standard native products only. This bar mirrors the existing form; it never
   chooses a variant, calculates an order price or sends its own cart request. */
(() => {
  function init() {
    const root = document.querySelector('.ef-standard-product-schema');
    const bar = document.getElementById('efStandardSticky');
    const form = root && root.querySelector('#efUniForm');
    const main = form && form.querySelector('#efUniATC');
    if (!root || !bar || !form || !main || bar.dataset.purchaseBound) return;
    const add = bar.querySelector('[data-standard-sticky-add]');
    const addLabel = add && (add.querySelector('[data-standard-sticky-label]') || add);
    const price = bar.querySelector('[data-standard-sticky-price]');
    const selection = bar.querySelector('[data-standard-sticky-selection]');
    const sourcePrice = root.querySelector('#efUniPriceCurrent');
    if (!add || !price || !selection || !sourcePrice) return;
    bar.dataset.purchaseBound = 'true';
    let variants = [];
    try { variants = JSON.parse(root.querySelector('#efUniVariantsData').textContent); } catch (_) { /* Native form remains authoritative. */ }
    document.addEventListener('ef:firepit-product-change', () => {
      try { variants = JSON.parse(root.querySelector('#efUniVariantsData').textContent); } catch (_) { variants = []; }
      const productTitle = bar.querySelector('.ef-standard-sticky__product > strong');
      const sourceTitle = root.querySelector('.efx-pdp__h1');
      if (productTitle && sourceTitle) text(productTitle, sourceTitle.textContent.trim());
      const thumbnail = bar.querySelector('.ef-standard-sticky__inner > img');
      const sourceImage = root.querySelector('#efGallerySwiper .ef-pd-slide img');
      if (thumbnail && sourceImage && sourceImage.getAttribute('src')) {
        const imageUrl = new URL(sourceImage.getAttribute('src'), location.href);
        imageUrl.searchParams.set('width', '120');
        thumbnail.src = imageUrl.href;
        thumbnail.removeAttribute('srcset');
      }
      queue();
    });
    const modalSelector = 'dialog[open], [aria-modal="true"], .calendly-overlay, .calendly-popup';
    let pending = false;
    function visibleModal() {
      return Array.from(document.querySelectorAll(modalSelector)).some(el =>
        el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'
      );
    }
    function text(el, value) { if (el.textContent !== value) el.textContent = value; }
    function sync() {
      pending = false;
      const label = main.querySelector('[data-atc-text]')?.textContent.trim() || main.textContent.trim();
      const variantId = form.querySelector('#efUniVariantId')?.value;
      const variant = variants.find(v => String(v.id) === String(variantId));
      const qty = form.querySelector('.ef-uni-qty__input')?.value || '1';
      const unavailable = /^Unavailable$/i.test(label);
      const title = !unavailable && variant?.title && variant.title !== 'Default Title' ? variant.title : '';
      text(price, sourcePrice.textContent.trim());
      text(selection, [unavailable ? 'Unavailable combination' : title, 'Qty ' + qty].filter(Boolean).join(' · '));
      const busy = form.dataset.efUniCartPending === 'true' || form.getAttribute('aria-busy') === 'true' || main.getAttribute('aria-busy') === 'true' || /^Adding/i.test(label);
      text(addLabel, form._efFirepitWizard && !form._efFirepitWizard.isReview() ? 'Review your fire pit' : form.dataset.efUniSwitchPending === 'true' ? 'Updating…' : busy ? 'Adding…' : /^Add to Cart/i.test(label) ? 'Add to cart' : label || 'Add to cart');
      const disabled = main.disabled || main.getAttribute('aria-disabled') === 'true' || busy;
      if (add.disabled !== disabled) add.disabled = disabled;
      if (add.getAttribute('aria-busy') !== String(busy)) add.setAttribute('aria-busy', String(busy));
      const hidden = main.getBoundingClientRect().bottom >= 0 || visibleModal();
      if (bar.hidden !== hidden) bar.hidden = hidden;
    }
    function queue() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(sync);
    }
    add.addEventListener('click', () => {
      // Read current state synchronously: native disabled/busy updates may happen
      // before the observer frame. A stale mirrored button must never submit.
      if (form.dataset.efUniCartPending === 'true' || form.getAttribute('aria-busy') === 'true' || main.disabled || main.getAttribute('aria-disabled') === 'true' || main.getAttribute('aria-busy') === 'true' || visibleModal()) { sync(); return; }
      if (form._efFirepitWizard && !form._efFirepitWizard.isReview()) { form._efFirepitWizard.review(); sync(); return; }
      main.click();
      sync();
    });
    new MutationObserver(queue).observe(form, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled', 'aria-disabled', 'aria-busy', 'data-ef-uni-cart-pending']});
    new MutationObserver(queue).observe(sourcePrice, {subtree:true, childList:true, characterData:true});
    ['click', 'input', 'change'].forEach(event => form.addEventListener(event, queue));
    document.addEventListener('ef:firepit-step-change', queue);
    window.addEventListener('scroll', queue, {passive:true});
    window.addEventListener('resize', queue, {passive:true});
    window.addEventListener('pageshow', queue);
    document.addEventListener('toggle', queue, true);
    // Observe only modal-related changes; bar mutations cannot schedule themselves.
    new MutationObserver(records => {
      if (records.some(record => record.type === 'attributes'
        ? record.target.matches('body, dialog, [aria-modal], .calendly-overlay, .calendly-popup')
        : [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches(modalSelector) || node.querySelector(modalSelector))))) queue();
    }).observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['class', 'open', 'hidden', 'aria-hidden', 'aria-modal', 'style']});
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(queue).observe(main);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
